import type { AdditionalFilterValuesFilterViews, AdditionalFilterValuesFormatted } from "@bbj-types/candidate";
import type { IDateRangeChipFilterView } from "@bbj-types/user";
import type { IDateRange, IDateRangeChip } from "@inputs/date/DateRangePicker/types";
import { Gender } from "@root/utils/constants/adminInformation";
import type { TAdditionalFieldFilterChips } from "@styleguide";
import type { SyntheticEvent } from "react";

export const isAdditionalDateFilterValue = (
  value: AdditionalFilterValuesFilterViews | null
): value is IDateRangeChip<TAdditionalFieldFilterChips> => {
  return Boolean(value && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date));
};

export const isAdditionalDateFilterValueFilterViews = (
  value: AdditionalFilterValuesFilterViews | null
): value is IDateRangeChipFilterView<TAdditionalFieldFilterChips> => {
  return Boolean(
    value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof Date) &&
      ((value.range?.startDate ?? value.range?.endDate) || value.chip)
  );
};

export const isAdditionalDateFilterValueFormatted = (
  value: AdditionalFilterValuesFormatted | null
): value is IDateRange => {
  return Boolean(
    value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof Date) &&
      (value.startDate ?? value.endDate)
  );
};

export const isSyntheticEvent = (event: object): event is SyntheticEvent => {
  return "nativeEvent" in event && event.nativeEvent instanceof Event;
};

export const isArrayOf = <T>(value: unknown, predicate: (item: unknown) => item is T): value is T[] => {
  return Array.isArray(value) && value.every(predicate);
};

export const isCandidateGender = (value: unknown): value is Gender => {
  return value === Gender.WOMAN || value === Gender.MAN;
};
